<app-toaster></app-toaster>
<app-loader></app-loader>
<router-outlet/>
@if (environment.environmentType == EnvironmentType.local || environment.environmentType == EnvironmentType.development) {
  <app-responsive-helper></app-responsive-helper>
}
